<div class="modal-container">
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h2 mat-dialog-title>Alertas - Capacidad {{data.ID_REG}}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="modal-content">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span>Listado de Alertas</span>
        <div class="d-flex align-items-center gap-2">
          <button mat-fab matTooltip="Histórico de alertas" (click)="abrirModalHistoricoAlertas()" class="fab-historico">
            <mat-icon>history</mat-icon>
          </button>
          <button mat-fab matTooltip="Nueva alerta" (click)="openDialog('new_alert',{ID_REG_CAPAC: data.ID_REG})" class="fab">
            <mat-icon>add</mat-icon>
          </button>
          <mat-form-field appearance="fill" class="search-field">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Buscar alerta">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="card-body" *ngIf="alertas.length === 0">
        <p class="text-center">No hay alertas para mostrar</p>
      </div>

      <div class="card-body overflow-auto" *ngIf="alertas.length > 0">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="ID_ALERT">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">ID</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.ID_ALERT}}</td>
          </ng-container>

          <ng-container matColumnDef="PORC_AVANCE">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">% AVANCE</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.PORC_AVANCE}}%</td>
          </ng-container>

          <ng-container matColumnDef="ASUNTO">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">ASUNTO</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.ASUNTO}}</td>
          </ng-container>

          <ng-container matColumnDef="DESTINATARIOS">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">DESTINATARIOS</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3" [innerHTML]="formatDestinatarios(element.DESTINATARIOS)"></td>
          </ng-container>

          <ng-container matColumnDef="ESTADO">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">ESTADO</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">
              <span [class]="element.ESTADO === 'A' ? 'badge-active' : 'badge-inactive'">
                {{element.ESTADO === 'A' ? 'Activo' : 'Inactivo'}}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="USUARIO_CREACION">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">USUARIO CREACIÓN</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.USUARIO_CREACION}} {{formatDate(element.FECHA_CREACION)}}</td>
          </ng-container>

          <ng-container matColumnDef="USUARIO_MODIFICACION">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">USUARIO MODIFICACION</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">{{element.USUARIO_MODIFICACION}} {{formatDate(element.FECHA_MODIFICACION)}}</td>
          </ng-container>

          <ng-container matColumnDef="ACCIONES">
            <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">ACCIONES</th>
            <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3">
              <button mat-icon-button matTooltip="Editar alerta" (click)="openDialog('edit_alert', element)" class="text-primary">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button
                      [matTooltip]="element.ESTADO === 'A' ? 'Desactivar' : 'Activar'"
                      (click)="openDialog('estado_alert', element)">
                <mat-icon>{{element.ESTADO === 'A' ? 'toggle_on' : 'toggle_off'}}</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <div mat-dialog-actions class="modal-actions">
    <button mat-button mat-dialog-close>Cerrar</button>
  </div>
</div>